import React from "react";
import { IovationScripts } from "tsi-common-react/src/components/IovationScripts/index";

import { Context, templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Template as ReviewsSPA } from "../../templates/ReviewsPageTemplate";
import { Template as WriteReviewButton } from "../../templates/WriteReviewButtonTemplate";

import styles from "./index.module.scss";

type IContentBlock =
    templates.ReviewsPageDocumentTemplate["hero_content"][number];

// Render one hero/footer content block. ``title`` is plain (autoescaped) JSX
// text; ``subtitle`` / ``text`` are server-expanded rich-text HTML injected
// via dangerouslySetInnerHTML (CMS-authored, same trust model as before).
export const renderContentBlock = (
    block: IContentBlock,
    index: number,
): React.JSX.Element => {
    switch (block.block_type) {
        case "title":
            return (
                <h2 key={index} className="customer-review__header-title">
                    {block.content}
                </h2>
            );
        case "subtitle":
            return (
                <div
                    key={index}
                    className="customer-review__header-subtitle"
                    dangerouslySetInnerHTML={{ __html: block.content }}
                />
            );
        case "text":
            return (
                <div
                    key={index}
                    className="reviews-standalone-footer__block"
                    dangerouslySetInnerHTML={{ __html: block.content }}
                />
            );
        default: {
            const _exhaustive: never = block.block_type;
            return _exhaustive;
        }
    }
};

// Mutable reactivated props (not Immutable<>): ReviewsSPA takes the mutable
// template props.
export const ReviewsPageBody = (
    props: templates.ReviewsPageDocumentTemplate,
): React.JSX.Element => {
    const {
        show_sources,
        hero_image_url,
        hero_content,
        product_type_whitelist_ids,
        iovation_url,
    } = props;
    const chrome = React.useContext(Context).chrome;

    const headerClass = concatClassNames([
        "customer-review__header",
        show_sources ? null : "customer-review__header--standalone",
        hero_content.length > 0 ? null : "customer-review__header--empty",
    ]);

    return (
        <>
            <div
                className={concatClassNames([
                    "hero",
                    styles.heroReviews,
                    hero_image_url ? null : styles.heroReviewsEmpty,
                ])}
                style={{ backgroundImage: `url('${hero_image_url}')` }}
            ></div>
            <div className="l-capped-width reviews-page-container">
                <div className="reviews-app-container">
                    <div className="customer-review l-capped-width">
                        <div className={headerClass}>
                            <div className="customer-review__header-copy">
                                {hero_content.map(renderContentBlock)}
                            </div>
                            {show_sources && (
                                <WriteReviewButton
                                    brand=""
                                    product_type_whitelist={
                                        product_type_whitelist_ids
                                    }
                                />
                            )}
                        </div>
                        <ReviewsSPA {...props} />
                    </div>
                </div>
            </div>
            <IovationScripts
                iovationUrl={iovation_url}
                staticBase={chrome.static_base}
            />
        </>
    );
};
